module.exports = __webpack_public_path__ + "static/Lancelot PianoWH-ee479265b958410a45e52c1938c377cc.png";